<template>
  <a-card>
    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="data" v-bind="{labelCol: { span: 8 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">

        <a-form-model-item
          prop="personCost"
          label="人力成本（元/人/月）">
          <a-input-number v-model="data.personCost" :min="1" :precision="0" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item
          prop="dayPatient"
          label="调查员每日采集受试者数量（人）">
          <a-input-number v-model="data.dayPatient" :min="1" :precision="0" style="width: 100%"/>
        </a-form-model-item>

      </a-form-model>
      <div style="text-align: right">
        <a-button :loading="confirmLoading" type="primary" @click="handleOk">确认</a-button>
      </div>
    </a-spin>
  </a-card>
</template>

<script>

  import baseRules from '@/constants/baseRules'
  import { putAction } from '@api/manage'

  export default {
    name: "TempConfigBaseSettingsItemPerson",
    props:{
      setting:{
        type:Object,
        default: ()=>{
          return {}
        },
      },
    },
    data () {
      return {
        confirmLoading: false,
        url: {
          edit: "/tempconfig/tempConfigBaseSettings/edit",
        },
        data:{},
        rules:{
          personCost:[baseRules.required],
          dayPatient:[baseRules.required],
        }
      }
    },
    created () {
      this.initData()
    },
    watch:{
      setting(){
        this.initData()
      }

    },
    methods: {
      initData(){
        if(this.setting.setting){
          this.data = JSON.parse(this.setting.setting)
        }else{
          this.data = {
            personCost:1,
            dayPatient:1,
          }
        }
      },
      handleOk () {
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            this.confirmLoading = true;
            let formData = Object.assign({id:this.setting.id,setting:JSON.stringify(this.data)},);

            putAction(this.url.edit,formData).then((res)=>{
              if(res.success){
                this.$message.success(res.message);
                this.$emit('submit');
              }else{
                this.$message.warning(res.message);
              }
            }).finally(() => {
              this.confirmLoading = false;
            })
          } else {
            return false;
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>

</style>